import React, { Component } from 'react'
import numeral from 'numeral'
import { FormattedMessage } from 'react-intl'

import {
  sumFinancialOutAmount,
  sumFinancialInAmount,
  financialOutItems,
  financialInItems,
} from '../data/Financial'

import {
  teachers,
  staffs
} from '../data/PersonnelStructure'

class FinancialReportAndPeopleStructure extends Component {
  renderFinancialReport() {
    return (
      <div>
        <table className="mb-8">
          <colgroup>
            <col style={{ width: '50%', minWidth: '50%' }}></col>
            <col style={{ width: '25%', minWidth: '25%' }}></col>
            <col style={{ width: '25%', minWidth: '25%' }}></col>
          </colgroup>
          <thead>
            <tr>
              <th colSpan="3"><FormattedMessage id="Actual expenditure for fiscal year 2017" /></th>
            </tr>
            <tr>
              <th><FormattedMessage id="Items" /></th>
              <th className="text-right"><FormattedMessage id="Actual expenditure" /></th>
              <th className="text-right">%</th>
            </tr>
          </thead>

          <tbody>
            {
              financialOutItems.map((item, i) => (
                <tr key={i}>
                  <td>{ item.name[this.props.langKey] }</td>
                  <td className="number">{ item.priceInDisplay }</td>
                  <td className="number">{ item.percentage }</td>
                </tr>
              ))
            }
            <tr className="table-footer">
              <td><FormattedMessage id="Total" /></td>
              <td className="number">{ numeral(sumFinancialOutAmount).format('0,0.00') }</td>
              <td className="number">100%</td>
            </tr>
          </tbody>
        </table>

        <table className="mb-8">
          <colgroup>
            <col style={{ width: '50%', minWidth: '50%' }}></col>
            <col style={{ width: '25%', minWidth: '25%' }}></col>
            <col style={{ width: '25%', minWidth: '25%' }}></col>
          </colgroup>
          <thead>
            <tr>
              <th colSpan="3"><FormattedMessage id="Actual income for fiscal year 2017" /></th>
            </tr>
            <tr>
              <th><FormattedMessage id="Items" /></th>
              <th className="text-right"><FormattedMessage id="Actual income" /></th>
              <th className="text-right">%</th>
            </tr>
          </thead>

          <tbody>
            {
              financialInItems.map((item, i) => (
                <tr key={i}>
                  <td>{ item.name[this.props.langKey] }</td>
                  <td className="number">{ item.priceInDisplay }</td>
                  <td className="number">{ item.percentage }</td>
                </tr>
              ))
            }

            <tr className="table-footer">
              <td><FormattedMessage id="Total" /></td>
              <td className="number">{ numeral(sumFinancialInAmount).format('0,0.00') }</td>
              <td className="number">100%</td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }

  renderPersonnelStructure() {
    return (
      <div>
        <table className="mb-8">
          <colgroup>
            <col style={{ width: '75%', minWidth: '75%' }}></col>
            <col style={{ width: '25%', minWidth: '25%' }}></col>
          </colgroup>
          <thead>
            <tr>
              <th colSpan="3"><FormattedMessage id="Full-time faculty statistics" /></th>
            </tr>
            <tr>
              <th><FormattedMessage id="Position" /></th>
              <th><FormattedMessage id="Number of people" /></th>
            </tr>
          </thead>

          <tbody>
            {
              teachers.map((item, i) => (
                <tr key={i}>
                  <td>{ item.name[this.props.langKey] }</td>
                  <td className="number">{ item.count }</td>
                </tr>
              ))
            }
            <tr className="table-footer">
              <td><FormattedMessage id="Total" /></td>
              <td className="number">{ teachers.reduce((prev, current) => (prev + current.count), 0)}</td>
            </tr>
          </tbody>
        </table>
        <table>
          <colgroup>
            <col style={{ width: '75%', minWidth: '75%' }}></col>
            <col style={{ width: '25%', minWidth: '25%' }}></col>
          </colgroup>
          <thead>
            <tr>
              <th colSpan="3"><FormattedMessage id="Full-time staff statistics" /></th>
            </tr>
            <tr>
              <th><FormattedMessage id="Position" /></th>
              <th><FormattedMessage id="Number of people" /></th>
            </tr>
          </thead>

          <tbody>
            {
              staffs.map((item, i) => (
                <tr key={i}>
                  <td>{ item.name[this.props.langKey] }</td>
                  <td className="number">{ item.count }</td>
                </tr>
              ))
            }
            <tr className="table-footer">
              <td><FormattedMessage id="Total" /></td>
              <td className="number">{ staffs.reduce((prev, current) => (prev + current.count), 0)}</td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }

  render() {
    return (
      <div>
        <div className="flex flex-row mb-8 text-center text-yellow-500 text-xl">
          {
            [
              'Income and Expenditure',
              'Human Captional'
            ].map((item, i) => (
              <button
                key={i}
                data-index={i}
                className={`switch-report-btn ${i===0 ? 'bg-gray-800' : 'bg-gray-700'} px-2 md:px-12 py-6 hover:bg-gray-800 font-medium focus:outline-none`}
              >
                <FormattedMessage id={item} />
              </button>
            ))
          }
        </div>

        <div data-report-index="0" className="block">
          <div className="mb-8">
            { this.props[`description1`] }
          </div>
          { this.renderFinancialReport() }
        </div>

        <div data-report-index="1" className="hidden">
          <div className="mb-8">
            { this.props[`description2`] }
          </div>
          { this.renderPersonnelStructure() }
        </div>
      </div>
    )
  }
}

export default FinancialReportAndPeopleStructure
